import { CITIES, STATIONS, DEPARTMENTS, DATA_ADD_LAST_DATA, DATA_ADD_NEW_DATA, DATA_INTEGRATION, DEPARTEMENTCODES, TOWNCODES, STATIONCODES, TTP, UDI, CAP, ARPEGE } from 'traitements/constants/TraitementConstants'

const CITY = 'CITY'
const STATION = 'STATIONS'
const DEPARTMENT = 'DEPARTMENTS'
const STATION_TYPE_OROBNAT = [CAP, TTP, UDI]
const getFilterHydro = (filters, listStation, options = {}) => {
    const closed = { doNotImportClosedStations: !!filters.doNotImportClosedStations }
    const stationsfilter = { stationsMode: STATIONS, stations: listStation.find(item => item[0] === STATIONS)?.[1] || [], ...closed }
    const citiesfilter = { stationsMode: CITIES, cities: options.noFind ? listStation : listStation.find(item => item[0] === CITIES)?.[1] || [], ...closed }
    const departmentfilter = { stationsMode: DEPARTMENTS, departments: options.noFind ? listStation : listStation.find(item => item[0] === DEPARTMENTS)?.[1] || [], ...closed }
    switch (filters.stationsMode) {
        case STATIONS:
            return [JSON.stringify(stationsfilter)]
        case CITIES:
            return [JSON.stringify(citiesfilter)]
        case DEPARTMENTS:
            return [JSON.stringify(departmentfilter)]
        default:
            return null
    }
}

const getParamHydro = (filters, listStation) => {
    switch (filters.stationsMode) {
        case STATIONS:
            return listStation.find(item => item[0] === STATIONS)?.[1] || []
        default :
            return []
    }
}


const getFilterPluvio = (filters, listStation, options = {}) => {
    const closed = { doNotImportClosedStations: !!filters.doNotImportClosedStations, closedStationYears: filters.closedStationYears ?? 2 }
    switch (filters.stationsMode) {
        case STATIONS:
            return [JSON.stringify({ rain: true, etp: true, radiation: true, temperature: true,
                codeMode: STATIONS, cityCodes: [], departmentCodes: [], stationsCodes: listStation.find(item => item[0] === STATIONS)?.[1] || [], ...closed })]
        case CITIES :
            return [JSON.stringify({ rain: true, etp: true, radiation: true, temperature: true,
                codeMode: CITIES, cityCodes: options.noFind ? listStation : listStation.find(item => item[0] === CITIES)?.[1] || [], departmentCodes: [], stationCodes: [], ...closed })]
        case DEPARTMENTS:
            return [JSON.stringify({ rain: true, etp: true, radiation: true, temperature: true,
                codeMode: DEPARTMENTS, cityCodes: [], departmentCodes: options.noFind ? listStation : listStation.find(item => item[0] === DEPARTMENTS)?.[1] || [], stationCodes: [], ...closed })]
        default :
            return null
    }
}

const getFilterERA5 = (filters, listStation, options = {}) => {
    switch (filters.stationsMode) {
        case CITIES :
            return [JSON.stringify({ codeMode: CITIES, cities: options.noFind ? listStation : listStation.find(item => item[0] === CITIES)?.[1] || [], departments: [],
                rain: true, etp: true, radiation: true, temperature: true, importMode: DATA_ADD_NEW_DATA, takePrincipal: true })]
        case DEPARTMENTS:
            return [JSON.stringify({ codeMode: DEPARTMENTS, cities: [], departments: options.noFind ? listStation : listStation.find(item => item[0] === DEPARTMENTS)?.[1] || [],
                rain: true, etp: true, radiation: true, temperature: true, importMode: DATA_ADD_NEW_DATA, takePrincipal: true })]
        default :
            return null
    }
}

const getFilterADES = (filters, listStation, options = {}) => {
    const closed = { doNotImportClosedStations: !!filters.doNotImportClosedStations }
    switch (filters.stationsMode) {
        case STATIONS:
            return [JSON.stringify({ codeMode: STATIONS, measureCote: 2, descriptionImportMode: 'all', selectStationsMode: 'newJob',
                syncEvents: true, syncNetworks: true, dontCheckInternalReferences: false, addCodesToADESNetwork: true, selectedNetwork: 2,
                stationCodes: listStation.find(item => item[0] === STATIONS)?.[1] || [], cityCodes: [], ...closed })]
        case CITIES :
            return [JSON.stringify({ codeMode: CITIES, measureCote: 2, descriptionImportMode: 'all', selectStationsMode: 'newJob',
                syncEvents: true, syncNetworks: true, dontCheckInternalReferences: false, addCodesToADESNetwork: true,
                stationCodes: [], cityCodes: options.noFind ? listStation : listStation.find(item => item[0] === CITIES)?.[1] || [], departmentCodes: [], selectedNetwork: 2, ...closed })]
        case DEPARTMENTS:
            return [JSON.stringify({ codeMode: DEPARTMENTS, measureCote: 2, descriptionImportMode: 'all', selectStationsMode: 'newJob',
                syncEvents: true, syncNetworks: true, dontCheckInternalReferences: false, addCodesToADESNetwork: true,
                stationCodes: [], cityCodes: [], departmentCodes: options.noFind ? listStation : listStation.find(item => item[0] === DEPARTMENTS)?.[1] || [], selectedNetwork: 2, ...closed })]
        default :
            return null
    }
}

const getFilterOROBNAT = (filters, listStation, options = {}) => {
    switch (filters.stationsMode) {
        case STATIONS:
            return [JSON.stringify({ stationTypes: STATION_TYPE_OROBNAT, codes: listStation.find(item => item[0] === STATIONS)?.[1] || [],
                codesType: STATIONCODES, producer: filters.producer })]
        case CITIES :
            return [JSON.stringify({ stationTypes: STATION_TYPE_OROBNAT, codes: options.noFind ? listStation : listStation.find(item => item[0] === CITIES)?.[1] || [],
                codesType: TOWNCODES, producer: filters.producer })]
        case DEPARTMENTS:
            return [JSON.stringify({ stationTypes: STATION_TYPE_OROBNAT, codes: options.noFind ? listStation : listStation.find(item => item[0] === DEPARTMENTS)?.[1] || [],
                codesType: DEPARTEMENTCODES, producer: filters.producer })]

        default :
            return null
    }
}

const getFilterPluvioEmprise = (filters, listStation, options = {}) => {
    switch (filters.stationsMode) {
        case STATIONS:
            return [JSON.stringify({ importMode: DATA_ADD_LAST_DATA, stationMode: 'BV', codes: options.noFind ? listStation : listStation.find(item => item[0] === STATIONS)?.[1] || [],
                histoType: 'SAFRAN', comblLastDays: true, comblType: ARPEGE, arome: true, arpege: true, ecmwf: true, ecmwfSeeds: false, rain: true,
                etp: true, etr: true, temperature: true, wind: true, humidity: true, soilHumidity: true, radiation: true, drain: true, runoff: true,
                humiditySpe: true, temperatureMin: true, temperatureMax: true, snow: true, ecmwfSeas: false, gefs: false })]
        case CITIES :
            return [JSON.stringify({ importMode: DATA_ADD_LAST_DATA, stationMode: CITY, codes: options.noFind ? listStation : listStation.find(item => item[0] === CITIES)?.[1] || [],
                histoType: 'SAFRAN', comblLastDays: true, comblType: ARPEGE, arome: true, arpege: true, ecmwf: true, ecmwfSeeds: false, rain: true,
                etp: true, etr: true, temperature: true, wind: true, humidity: true, soilHumidity: true, radiation: true, drain: true, runoff: true,
                humiditySpe: true, temperatureMin: true, temperatureMax: true, snow: true, ecmwfSeas: false, gefs: false })]
        default :
            return null
    }
}

const getFilterMFRadar = (filters, listStation, options = {}) => {
    switch (filters.stationsMode) {
        case STATIONS:
            return [JSON.stringify({ importMode: DATA_ADD_LAST_DATA, stationsMode: STATION, stations: listStation.find(item => item[0] === STATIONS)?.[1] || [],
                cities: [], departments: [], rain: true, etp: true, temperature: true, radiation: true })]
        case CITIES :
            return [JSON.stringify({ importMode: DATA_ADD_LAST_DATA, stationsMode: CITY, stations: [], cities: options.noFind ? listStation : listStation.find(item => item[0] === CITIES)?.[1] || [],
                departments: [], rain: true, etp: true, temperature: true, radiation: true })]
        case DEPARTMENTS :
            return [JSON.stringify({ importMode: DATA_ADD_LAST_DATA, stationsMode: DEPARTMENT, stations: [], cities: [],
                departments: options.noFind ? listStation : listStation.find(item => item[0] === DEPARTMENTS)?.[1] || [], rain: true, etp: true, temperature: true, radiation: true })]
        default :
            return null
    }
}

const getFilterOndes = (filters, listStation, options = {}) => {
    switch (filters.stationsMode) {
        case STATIONS:
            return [JSON.stringify({ codeMode: STATIONS, stationIntegration: true,
                codes: listStation.find(item => item[0] === STATIONS)?.[1] || [], dataIntegration: DATA_INTEGRATION })]
        case CITIES :
            return [JSON.stringify({ codeMode: CITIES, stationIntegration: true,
                codes: options.noFind ? listStation : listStation.find(item => item[0] === CITIES)?.[1] || [], dataIntegration: DATA_INTEGRATION })]
        case DEPARTMENTS :
            return [JSON.stringify({ codeMode: DEPARTMENTS, stationIntegration: true,
                codes: options.noFind ? listStation : listStation.find(item => item[0] === DEPARTMENTS)?.[1] || [], dataIntegration: DATA_INTEGRATION })]
        default :
            return null
    }
}

export {
    getParamHydro,
    getFilterHydro,
    getFilterOndes,
    getFilterADES,
    getFilterERA5,
    getFilterMFRadar,
    getFilterOROBNAT,
    getFilterPluvio,
    getFilterPluvioEmprise,
}
